import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';

export function useAllowedRegion(): boolean {
  const ctx = useGeoLookupContext();

  if (ctx != null) {
    const { country, region } = ctx;
    if (country === 'US' && region === 'CA') return false;
  }

  return true;
}
